
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, IconButton, Tab, Tabs, } from '@material-ui/core';
import TabIndicator from '../view/TabIndicator';
import AppConfig from '../../control/config';

const ICON = require("../../images/icons/shaixuan.png");

class MatchHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
        };
    }

    _handleChange(val) {
        this.setState({ value: val });
        this.props.onChange && this.props.onChange(this.props.data[val]);
    }

    _onClickLeagueMatch = () => {
        this.props.history.push('matchleague');
    }
    // this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    //跳到赛事
    _onClickChoose() {
        // let id = type_id
        let id = this.props.data[this.state.value].type_id
        // this.props.history.push({ pathname: 'matchchoose', data: this.props.data[this.state.value] });
        this.props.history.push({ pathname: '/matchchoose/'+ id });
    }

    render() {
        const { classes, data, num } = this.props;
        const { value } = this.state;
        return (
            <Grid container justifyContent='space-between' alignItems='center' direction='row' style={{ width: '100vw' }} >
                <Grid container alignItems='center' justifyContent='center' style={{ maxWidth: '100vw' }}>
                    {
                        data && data.length != 0 && <Tabs
                            variant='scrollable'
                            value={value}
                            onChange={(e, val) => this._handleChange(val)}
                            TabIndicatorProps={{ children: <TabIndicator width={30} background={AppConfig.tabLineColoor} />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                        >
                            {
                                data.map((item, i) => (
                                    <Tab key={i} label={item.type_name} style={{ color: '#0D0D0D', opacity: 1, fontSize: value == i ? 17 : 14, fontWeight: value == i ? 'bold' : 'normal' }}></Tab>
                                ))
                            }
                        </Tabs>
                    }

                </Grid>
                {/* <Grid container justifyContent='flex-end' alignItems='center' direction='row' style={{ maxWidth: '40vw' }} >
                    <IconButton className={classes.iconButton} onClick={() => this._onClickChoose()}>
                        <img src={ICON} style={{ width: 17, height: 13.5, marginRight: 16, marginLeft: 16 }}  ></img>
                    </IconButton>
                </Grid> */}
            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    button: {
        border: '1px solid ' + theme.palette.primary.main,
        backgroundColor: '#FFF',
        textAlign: 'center',
        borderRadius: 15,
        fontSize: 11,
        padding: theme.spacing(0.5, 1, 0.5, 1),
        color: theme.palette.primary.main,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
    }
}))(MatchHeader));